var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CalenderConfigs } from "@yodlee/common-components/dist/configurations";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { Col, Divider, Form, Icon, Modal, Row, Spin, Typography } from "antd";
import moment from "moment";
import React from "react";
import MediaQuery from "react-responsive";
import { FormFieldConfigs } from "../../configurations";
import { DataUtils, ParserUtils } from "../../utilities";
import LeftView from "./left-view";
import RightView from "./right-view";
moment.updateLocale('en', {
    calendar: CalenderConfigs.MOMENT_CALENDER
});
var UpdateIncident = /** @class */ (function (_super) {
    __extends(UpdateIncident, _super);
    function UpdateIncident() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            onFormUpdated: false
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var onFormUpdate = _this.props.onFormUpdate;
            var isFieldsTouched = _this.props.form.isFieldsTouched;
            var onFormUpdated = _this.state.onFormUpdated;
            var oldOnFormUpdated = prevState.onFormUpdated;
            if (onFormUpdate && isFieldsTouched() && !onFormUpdated && !oldOnFormUpdated) {
                _this.setState({
                    onFormUpdated: true
                }, function () {
                    onFormUpdate();
                });
            }
        };
        _this.componentDidMount = function () {
            var _a = _this.props, authentication = _a.authentication, incident = _a.incident;
            DataUtils.systemConfig(authentication).get().then(function (onload) {
                _this.setState({ onload: onload });
            });
            if (incident.id) {
                DataUtils.incidents(authentication).getOne(incident.id).then(function (incident) {
                    _this.setState({ incident: incident });
                });
            }
        };
        _this.onSubmit = function (e) {
            var _a = _this.props.form, validateFieldsAndScroll = _a.validateFieldsAndScroll, resetFields = _a.resetFields;
            var incident = _this.state.incident;
            var _b = _this.props, authentication = _b.authentication, onUpdate = _b.onUpdate;
            e.preventDefault();
            e.stopPropagation();
            var updateIncident = function (values) {
                var _a;
                _this.setState({
                    isLoading: true
                });
                var newIncident = __assign({}, values);
                if (newIncident.nextUpdateValue) {
                    newIncident.nextUpdatePeriod = newIncident.nextUpdateValue;
                    delete newIncident.nextUpdateValue;
                }
                else if (!newIncident.nextUpdateValue && !newIncident.nextUpdatePeriod)
                    newIncident.nextUpdatePeriod = "";
                if (!newIncident.bugId)
                    newIncident.bugId = 0;
                var parsedStartTime = newIncident.startTime ? moment(newIncident.startTime).valueOf() : undefined;
                if (parsedStartTime !== (incident === null || incident === void 0 ? void 0 : incident.startTime)) {
                    newIncident.startTime = parsedStartTime;
                }
                else {
                    delete newIncident.startTime;
                }
                var parseEndTime = newIncident.endTime ? moment(newIncident.endTime).valueOf() : undefined;
                if (parseEndTime !== (incident === null || incident === void 0 ? void 0 : incident.endTime)) {
                    newIncident.endTime = parseEndTime;
                }
                else {
                    delete newIncident.endTime;
                }
                if (newIncident.downTime && newIncident.downTime.type.id === -1) {
                    delete newIncident.downTime;
                }
                else {
                    var parsedValues = ParserUtils.parseTimeUnit(newIncident.downTime.estimatedDuration, false);
                    if (parsedValues.unit === "minutes") {
                        newIncident.downTime.estimatedDuration = "PT".concat(parsedValues.value, "M");
                    }
                    else {
                        newIncident.downTime.estimatedDuration = "PT".concat(parsedValues.value, "H");
                    }
                    if (newIncident.downTime.actualDuration) {
                        parsedValues = ParserUtils.parseTimeUnit(newIncident.downTime.actualDuration, false);
                        if (parsedValues.unit === "minutes") {
                            newIncident.downTime.actualDuration = "PT".concat(parsedValues.value, "M");
                        }
                        else {
                            newIncident.downTime.actualDuration = "PT".concat(parsedValues.value, "H");
                        }
                    }
                }
                var formData = new FormData();
                if (newIncident.files) {
                    (_a = newIncident.files) === null || _a === void 0 ? void 0 : _a.forEach(function (file) {
                        formData.append("attachments", file.originFileObj);
                    });
                    delete newIncident.files;
                }
                var incidentRequestBlob = new Blob([JSON.stringify(newIncident)], {
                    type: 'application/json'
                });
                formData.append("incidentRequest", incidentRequestBlob);
                DataUtils.incidents(authentication).updateOne(incident === null || incident === void 0 ? void 0 : incident.id, formData).then(function (incident) {
                    _this.setState({ incident: incident });
                    onUpdate && onUpdate(incident);
                }).finally(function () {
                    _this.setState({
                        isLoading: false,
                        onFormUpdated: false
                    });
                    resetFields([
                        "files",
                        "updates.".concat(FormFieldConfigs.PARTIAL_CLOSURE.key),
                        FormFieldConfigs.ACTUAL_DOWN_TIME_VALUE.key,
                        "updates.".concat(FormFieldConfigs.COMMENT.key),
                        "updates.".concat(FormFieldConfigs.BRANDS.key),
                        "updates.".concat(FormFieldConfigs.INTERNAL_NOTE.key),
                        FormFieldConfigs.NOTIFICATION_RCA.key
                    ]);
                });
            };
            validateFieldsAndScroll(function (err, values) {
                var _a;
                console.debug('Received values of serviceRequestForm: ', values, err);
                if (!err && (incident === null || incident === void 0 ? void 0 : incident.id)) {
                    if (((_a = values.updates) === null || _a === void 0 ? void 0 : _a.isInternal) === false) {
                        Modal.confirm({
                            keyboard: false,
                            title: React.createElement(Typography.Title, { className: "color-blue-5", level: 2 },
                                "A notification will be sent out to customers. Are you sure?",
                                React.createElement("br", null)),
                            icon: null,
                            width: "450px",
                            okText: "Send Update",
                            cancelButtonProps: { type: "danger" },
                            onOk: function () { return updateIncident(values); }
                        });
                    }
                    else {
                        updateIncident(values);
                    }
                }
            });
        };
        _this.downloadAttachment = function (attachmentId, fileName) {
            var authentication = _this.props.authentication;
            var incident = _this.state.incident;
            if (incident === null || incident === void 0 ? void 0 : incident.id) {
                DataUtils.incidents(authentication).downloadAttachment(incident.id, attachmentId, fileName);
            }
        };
        _this.render = function () {
            var _a = _this.state, onload = _a.onload, incident = _a.incident, isLoading = _a.isLoading;
            return (onload && incident ?
                React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                    return React.createElement(Form, { onSubmit: _this.onSubmit, colon: false, layout: "horizontal" },
                        React.createElement(Row, { type: "flex", style: { width: '100%' } },
                            React.createElement(Col, { xxl: 7, xl: 7, lg: 7, md: 24, sm: 24, xs: 24, order: matches ? 1 : 3, className: matches ? "padding-right-lg" : "" },
                                React.createElement(LeftView, { form: _this.props.form, incident: incident, onload: onload, isLoading: isLoading })),
                            React.createElement(Col, { xs: 24, sm: 24, md: 24, lg: 0, xl: 0, xxl: 0, order: 2 },
                                React.createElement(Divider, null)),
                            React.createElement(Col, { xxl: 17, xl: 17, lg: 17, md: 24, sm: 24, xs: 24, order: matches ? 3 : 1, className: matches ? "padding-left-lg border-left" : "" },
                                React.createElement(RightView, { form: _this.props.form, onload: onload, incident: incident, isLoading: isLoading, downloadAttachment: _this.downloadAttachment }))));
                }) :
                React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return UpdateIncident;
}(React.Component));
export default Form.create({ name: 'update-incident' })(UpdateIncident);
//# sourceMappingURL=index.js.map